module.exports = __webpack_public_path__ + "static/greek-salad-mix-a527d8397efcf350a93d690da42b737c.png";